/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlayerRestrictionState } from './PlayerRestrictionState';
import {
    PlayerRestrictionStateFromJSON,
    PlayerRestrictionStateFromJSONTyped,
    PlayerRestrictionStateToJSON,
} from './PlayerRestrictionState';
import type { RestrictionStatus } from './RestrictionStatus';
import {
    RestrictionStatusFromJSON,
    RestrictionStatusFromJSONTyped,
    RestrictionStatusToJSON,
} from './RestrictionStatus';
import type { RuleType } from './RuleType';
import {
    RuleTypeFromJSON,
    RuleTypeFromJSONTyped,
    RuleTypeToJSON,
} from './RuleType';

/**
 * 
 * @export
 * @interface AdminPlayerRestriction
 */
export interface AdminPlayerRestriction {
    /**
     * Note recorded when the restriction was overridden.
     * @type {string}
     * @memberof AdminPlayerRestriction
     */
    overrideNote?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerRestriction
     */
    overrideAt?: Date | null;
    /**
     * Internal back-office user id (uuid) who overrode (lifted) the restriction.
     * @type {string}
     * @memberof AdminPlayerRestriction
     */
    overrideUserId?: string | null;
    /**
     * `null` when the lockout is indefinite; otherwise the moment the tier lapses.
     * @type {Date}
     * @memberof AdminPlayerRestriction
     */
    probationExpiresAt?: Date | null;
    /**
     * `null` when the lockout is indefinite.
     * @type {Date}
     * @memberof AdminPlayerRestriction
     */
    lockoutExpiresAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerRestriction
     */
    appliedAt: Date;
    /**
     * Note recorded when the restriction was manually applied.
     * @type {string}
     * @memberof AdminPlayerRestriction
     */
    applyNote?: string | null;
    /**
     * Internal back-office user id (uuid) who manually applied the restriction. Absent for rule-triggered restrictions.
     * @type {string}
     * @memberof AdminPlayerRestriction
     */
    appliedByUserId?: string | null;
    /**
     * Index into the configured penalty ladder, captured at apply time.
     * @type {number}
     * @memberof AdminPlayerRestriction
     */
    penaltyTier: number;
    /**
     * 
     * @type {RestrictionStatus}
     * @memberof AdminPlayerRestriction
     */
    status: RestrictionStatus;
    /**
     * Scan that triggered the restriction. Absent for manually-applied restrictions.
     * @type {string}
     * @memberof AdminPlayerRestriction
     */
    triggeringScanId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerRestriction
     */
    ruleId: string;
    /**
     * 
     * @type {RuleType}
     * @memberof AdminPlayerRestriction
     */
    ruleType: RuleType;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof AdminPlayerRestriction
     */
    playerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof AdminPlayerRestriction
     */
    customerId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof AdminPlayerRestriction
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerRestriction
     */
    playerLookupId: string;
    /**
     * Whether the player is currently locked out of scanning or only within a probation window.
     * @type {PlayerRestrictionState}
     * @memberof AdminPlayerRestriction
     */
    restrictionState: PlayerRestrictionState;
}



/**
 * Check if a given object implements the AdminPlayerRestriction interface.
 */
export function instanceOfAdminPlayerRestriction(value: object): value is AdminPlayerRestriction {
    if (!('appliedAt' in value) || value['appliedAt'] === undefined) return false;
    if (!('penaltyTier' in value) || value['penaltyTier'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('ruleId' in value) || value['ruleId'] === undefined) return false;
    if (!('ruleType' in value) || value['ruleType'] === undefined) return false;
    if (!('playerId' in value) || value['playerId'] === undefined) return false;
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('playerLookupId' in value) || value['playerLookupId'] === undefined) return false;
    if (!('restrictionState' in value) || value['restrictionState'] === undefined) return false;
    return true;
}

export function AdminPlayerRestrictionFromJSON(json: any): AdminPlayerRestriction {
    return AdminPlayerRestrictionFromJSONTyped(json, false);
}

export function AdminPlayerRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPlayerRestriction {
    if (json == null) {
        return json;
    }
    return {
        
        'overrideNote': json['overrideNote'] == null ? undefined : json['overrideNote'],
        'overrideAt': json['overrideAt'] == null ? undefined : (new Date(json['overrideAt'])),
        'overrideUserId': json['overrideUserId'] == null ? undefined : json['overrideUserId'],
        'probationExpiresAt': json['probationExpiresAt'] == null ? undefined : (new Date(json['probationExpiresAt'])),
        'lockoutExpiresAt': json['lockoutExpiresAt'] == null ? undefined : (new Date(json['lockoutExpiresAt'])),
        'appliedAt': (new Date(json['appliedAt'])),
        'applyNote': json['applyNote'] == null ? undefined : json['applyNote'],
        'appliedByUserId': json['appliedByUserId'] == null ? undefined : json['appliedByUserId'],
        'penaltyTier': json['penaltyTier'],
        'status': RestrictionStatusFromJSON(json['status']),
        'triggeringScanId': json['triggeringScanId'] == null ? undefined : json['triggeringScanId'],
        'ruleId': json['ruleId'],
        'ruleType': RuleTypeFromJSON(json['ruleType']),
        'playerId': json['playerId'],
        'customerId': json['customerId'],
        'id': json['id'],
        'playerLookupId': json['playerLookupId'],
        'restrictionState': PlayerRestrictionStateFromJSON(json['restrictionState']),
    };
}

export function AdminPlayerRestrictionToJSON(value?: AdminPlayerRestriction | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'overrideNote': value['overrideNote'],
        'overrideAt': value['overrideAt'] == null ? undefined : ((value['overrideAt'] as any).toISOString()),
        'overrideUserId': value['overrideUserId'],
        'probationExpiresAt': value['probationExpiresAt'] == null ? undefined : ((value['probationExpiresAt'] as any).toISOString()),
        'lockoutExpiresAt': value['lockoutExpiresAt'] == null ? undefined : ((value['lockoutExpiresAt'] as any).toISOString()),
        'appliedAt': ((value['appliedAt']).toISOString()),
        'applyNote': value['applyNote'],
        'appliedByUserId': value['appliedByUserId'],
        'penaltyTier': value['penaltyTier'],
        'status': RestrictionStatusToJSON(value['status']),
        'triggeringScanId': value['triggeringScanId'],
        'ruleId': value['ruleId'],
        'ruleType': RuleTypeToJSON(value['ruleType']),
        'playerId': value['playerId'],
        'customerId': value['customerId'],
        'id': value['id'],
        'playerLookupId': value['playerLookupId'],
        'restrictionState': PlayerRestrictionStateToJSON(value['restrictionState']),
    };
}

